export default __webpack_public_path__ + "static/media/monelevage-logo-1024x1024-white.9ef55e81.svg";